import { useAppBuildTokenBridge } from '@/hooks/useAppBuildTokenBridge';

/**
 * Invisible component that activates the AppBuild push token bridge.
 * Placed at the app root to ensure token enrichment runs on every load.
 */
export const AppBuildTokenBridgeProvider = () => {
  useAppBuildTokenBridge();
  return null;
};
